import React, { Component } from 'react';
import { Col, FormGroup, ControlLabel } from 'react-bootstrap';
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import Api from '../../../../../Global/Modules/Api'

const FETCH_URL_INSTITUTIONS_OPLEIDINGEN = "api/educations/knowntraining/institutions"
const FETCH_URL_COURSES_OPLEIDINGEN = "api/educations/knowntraining/names"
const FETCH_URL_INSTITUTIONS_CURSUS = "api/educations/course/institutions"
const FETCH_URL_COURSES_CURSUS = "api/educations/course/names"

class RegularSearch extends Component {
    constructor(props) {
        super(props)
        this.handleInstituteChange = this.handleInstituteChange.bind(this)
        this.handleCourseChange = this.handleCourseChange.bind(this)
        this.state = {
            institutions: [],
            selectedInstitution: null,
            courses: [],
            selectedCourse: null
        }
    }

    componentDidMount() {
        Api.print(`Type: ${this.props.type}`)
        let fetchUrl = this.props.type === "O" ? FETCH_URL_INSTITUTIONS_OPLEIDINGEN : FETCH_URL_INSTITUTIONS_CURSUS + "/" + this.props.type
        Api.GetApi(fetchUrl).then(data => {
            let institutions = data.institutions.map(i => {
                return { label: i.name, value: i.id }
            })
            this.setState({ institutions: institutions })
        })
    }

    handleInstituteChange(newValue) {
        Api.print(`Institution value: ${newValue}`)
        this.props.onUpdate('institution', newValue)
        this.props.onUpdate('course', null)
        this.props.onUpdate('points', '')

        let fetchUrl = this.props.type === "O" ? `${FETCH_URL_COURSES_OPLEIDINGEN}/${newValue}` : `${FETCH_URL_COURSES_CURSUS}/${newValue}`
        if (newValue) { // newValue is not null
            Api.GetApi(fetchUrl).then(data => {
                let courses = data.courses.map(c => {
                    return { label: c.name, value: c.id, points: c.points, diploma: c.diploma }
                })
                this.setState({
                    selectedInstitution: newValue,
                    courses: courses,
                    selectedCourse: null
                })
            })
        }

        else
            this.setState({
                selectedInstitution: newValue,
                courses: [],
                selectedCourse: null
            })
    }
    // When a course change its value
    handleCourseChange(newValue) {
        Api.print(`Course value: ${newValue}`)
        this.setState({ selectedCourse: newValue })
        this.props.onUpdate('course', newValue) // Notify the course change to the parent

        if (newValue) { // newValue is not null
            let course = this.state.courses.find(c => c.value === newValue)
            this.props.onUpdate('points', course.points) // Notify the points change to the parent
            this.props.onUpdate('diploma', course.diploma) // Notify the requirement of the diploma to the parent
        }

        else {
            this.props.onUpdate('points', '') // Notify the points change to the parent
            this.props.onUpdate('diploma', null) // Notify the requirement of the diploma to the parent
        }


    }

    render() {
        return (
            <div>
                {/* TODO: Create regular search on instituut and name. in all courses en knowledge, and filter this per type of page. */}

                <FormGroup controlId="regularSearchBoxInstituut">
                    <Col componentClass={ControlLabel} sm={4}>
                        Instituut
                            </Col>
                    <Col sm={6}>
                        <Select
                            id="institution-select"
                            options={this.state.institutions}
                            simpleValue
                            autoFocus
                            name="selectedInstitution"
                            disabled={false}
                            value={this.state.selectedInstitution}
                            onChange={this.handleInstituteChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="regularSearchBoxCursus">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam
                            </Col>
                    <Col sm={6}>
                        <Select
                            id="course-select"
                            options={this.state.courses}
                            simpleValue
                            name="selectedCourse"
                            disabled={false}
                            value={this.state.selectedCourse}
                            onChange={this.handleCourseChange}
                        />
                    </Col>
                </FormGroup>
            </div>
        )
    };

}

export default RegularSearch;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/RegularSearch.js